import React from "react"
import {
  Container,
  BlurWrapper,
  Thumbnail,
  ContentWrapper,
  Content,
  Paragraph,
  Year,
  Image,
  Name,
  GContainer,
  GLink,
  TimeAndDate,
  IconWithText,
  Title,
  Text,
} from "./styles/singleHero"
import { Icon, Skeleton } from "../../components"
import { Container as MainContainer } from "../../containers"

export default function SingleMovieHero({ children, path, ...rest }) {
  return (
    <Container {...rest} path={path}>
      <BlurWrapper>
        <MainContainer>
          <ContentWrapper>{children}</ContentWrapper>
        </MainContainer>
      </BlurWrapper>
    </Container>
  )
}

SingleMovieHero.Thumbnail = function heroThumbnail({ src, ...rest }) {
  return (
    <Thumbnail {...rest}>
      {src ? <Image src={`https://image.tmdb.org/t/p/w500${src}`} alt="Movie-Thumb" /> : ""}
    </Thumbnail>
  )
}

SingleMovieHero.Content = function heroContent({ children, ...rest }) {
  return <Content {...rest}>{children}</Content>
}

SingleMovieHero.Name = function heroName({ children, year, ...rest }) {
  // return <Name {...rest}>{children ? children : <Skeleton.Title />}</Name>
  return (
    <>
      {children ? (
        <Name {...rest}>
          {children} <Year>({year})</Year>
        </Name>
      ) : (
        <Skeleton.SingleLine type="true" w="40" />
      )}
    </>
  )
}

SingleMovieHero.GContainer = function heroGContainer({ children, ...rest }) {
  return <GContainer {...rest}>{children}</GContainer>
}

SingleMovieHero.GLink = function heroGLink({ children, to, ...rest }) {
  return (
    <>
      {children ? (
        <GLink {...rest} to={to}>
          {children}
        </GLink>
      ) : (
        <>
          <Skeleton.SingleLine type="true" w="20" />
          <Skeleton.SingleLine type="true" w="20" />
          <Skeleton.SingleLine type="true" w="20" />{" "}
        </>
      )}
    </>
  )
}

SingleMovieHero.TimeAndDate = function heroTimeAndDate({ children, ...rest }) {
  return <TimeAndDate {...rest}>{children}</TimeAndDate>
}

SingleMovieHero.IconWithText = function heroIconWithText({ icon, text, ...rest }) {
  return (
    <IconWithText {...rest}>
      <Icon name={icon} />
      <Paragraph>{text}</Paragraph>
    </IconWithText>
  )
}

SingleMovieHero.Title = function heroTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

SingleMovieHero.Text = function heroText({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>
}

// SingleMovieHero.OverviewText = function heroText({ children, ...rest }) {
//   return <>{children ? <Text {...rest}>{children}</Text> : <Skeleton.ThreeLine w="80" />}</>
// }

SingleMovieHero.OverviewText = function heroText({ children, ...rest }) {
  return <>{children ? <Text {...rest}>{children}</Text> : <Skeleton.ThreeLine w="80" />}</>
}
